import { Box, Heading, HStack, type StackProps, Text } from "@chakra-ui/react";
import type { PlanningDailyViewUserByDayModel } from "@src/components/modules/resource-planning/timeline/models";
import { Avatar } from "@src/components/ui-kit";
import { COLUMN_HEADER_HEIGHT } from "@src/constants/planning";
import type { FunctionComponent } from "react";

export type AllocationsColumnUserHeaderProps = {
  user: PlanningDailyViewUserByDayModel["user"];
} & StackProps;

export const AllocationsColumnUserHeader: FunctionComponent<
  AllocationsColumnUserHeaderProps
> = ({ user, ...props }) => {
  return (
    <HStack
      h={COLUMN_HEADER_HEIGHT}
      px="2"
      bg="white"
      borderColor="grey.100"
      borderTopWidth="1px"
      borderRightWidth="1px"
      borderBottomWidth="1px"
      {...props}
    >
      <Avatar
        mr="1"
        colorScheme={user.profile?.hex_color}
        name={user ? user.full_name : "?"}
        src={
          user?.image?.urls.thumbnail ? user.image?.urls.thumbnail : undefined
        }
      />
      <HStack justify="space-between" flex="1">
        <Box flex="1" pr="4">
          <Heading fontSize="small" wordBreak="break-all" noOfLines={1}>
            {user.full_name}
          </Heading>
          <Text
            color="grey.600"
            fontSize="xs"
            wordBreak="break-all"
            noOfLines={1}
          >
            {user.profile?.defaultWorktype.title} / {user.team?.name}
          </Text>
        </Box>
      </HStack>
    </HStack>
  );
};
